import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import PosMemberWorkPlaceListFilter from "../Filters/PosMemberWorkPlaceListFilter";
import PosTerminalUpdateForm from "../Forms/PosTerminalUpdateForm";

const PosMemberWorkPlace = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "ÜYE İŞYERİ - TERMİNAL LİSTESİ",
  });
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [isUseForErp, setIsUseForErp] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=bankId asc";
    let query = "";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/PosMemberWorkPlace?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (query.includes("PosTerminals")) {

        const filterQuery = query
        const numberPattern =  /(?:eq ')([A-Za-z0-9]+)(?:')/;
        const match = filterQuery.match(numberPattern);

        response.value.forEach(
          (item) =>
            (item.posTerminals = item.posTerminals.filter(
              (innerItem) => innerItem.number == `${match[1]}`
            ))
        );
      }
      setTableData({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(
      `/PosMemberWorkPlace/GetPosTerminalById/${record.id}`
    ).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const onUpdatePosTerminalSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      align: "center",
      width: "10%",
      render: (text) => <img src={text}></img>,
    },
    // {
    //   title: "Üye İş Yeri Adedi",
    //   dataIndex: "memberWorkPlaceCount",
    // },
    {
      title: "Üye İş Yeri Adı",
      dataIndex: "name",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 80).length < 80
              ? text.substring(0, 80) + ""
              : text.substring(0, 80) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Üye İş Yeri Numarası",
      dataIndex: "number",
    },
  ];

  const expandedRowDetailsColumns = [
    {
      title: "Terminal Adı",
      dataIndex: "name",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 80).length < 80
              ? text.substring(0, 80) + ""
              : text.substring(0, 80) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Terminal Numarası",
      dataIndex: "number",
    },
    {
      title: "Pos Hesap Kodu",
      dataIndex: "erpBankAccountCode",
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => handleOnClickUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {

      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  // const expandedRowRender = (data) => {
  //   return (
  //     <Table
  //       columns={expandedRowColumns}
  //       size="small"
  //       dataSource={data}
  //       pageable={true}
  //       pagination={{
  //         defaultPageSize: 15,
  //         pageSizeOptions: ["15", "25", "50"],
  //         total: data.length,
  //       }}
  //       expandable={{
  //         expandedRowRender: (record) =>
  //           expendedRowRenderDetail(record.posTerminals),
  //         rowExpandable: (record) => record.posTerminals !== null,
  //       }}
  //       rowKey="id"
  //     />
  //   );
  // };

  const expendedRowRenderDetail = (data) => {
    return (
      <Table
        columns={expandedRowDetailsColumns}
        size="small"
        dataSource={data}
        pageable={true}
        pagination={{
          defaultPageSize: 15,
          pageSizeOptions: ["15", "25", "50"],
          total: data.length,
        }}
        rowKey="id"
      />
    );
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>
      <PosMemberWorkPlaceListFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      ></PosMemberWorkPlaceListFilter>
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            expandable={{
              expandedRowRender: (record) =>
                expendedRowRenderDetail(record.posTerminals),
              rowExpandable: (record) => record.posTerminals !== null,
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="number"
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="updatePosTerminalDrawer"
        title="Pos Terminal Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <PosTerminalUpdateForm
          data={updateFormData}
          onSuccess={onUpdatePosTerminalSuccess}
        />
      </Drawer>
    </>
  );
};

export default PosMemberWorkPlace;
